<template>
    <transition name="slide-fade">
        <div v-if="visible" class="content-wrapper">
            <div class="unwrap" v-if="unwrap">
                <slot></slot>
            </div>
            <slot v-else></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'ContentWrapper',
        props: {
            unwrap: Boolean
        },
        data() {
            return {
                visible: false
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.visible = true
                }, 300)
            })
        }
    }
</script>